import axios from "./index";

class Routes {
  addNotification(data) {
    return axios.post(`/notification`, data);
  }
  sendNotification(data) {
    return axios.post(`/notification/send`, data);
  }
  getNotifications(id) {
    return axios.get(`/notification/${id}`);
  }

  getAdminNotifications() {
    return axios.get(`/notification`);
  }

  readNotification(id) {
    return axios.patch(`/notification/${id}`);
  }

  clearAllNotifications(id) {
    return axios.delete(`/notification/${id}`);
  }
}

export default new Routes();
